import { ISelectItem } from "@/types";
import {
  IAlert,
  IAlertCreateRequest,
  IAlertListRequest,
  IAlertRequest,
  IAlertUpdateRequest,
} from "@/types/alert";
import { ListRequest } from "./listRequest";
import { Member } from "./member";

export class Alert implements IAlert {
  public id = 0;
  public alertconsition_id = 0;
  public company_id = 0;
  public member_id = 0;
  public tag_id = 0;
  public name = "";
  public member = new Member();

  public constructor(props?: IAlert) {
    if (!props) {
      return;
    }

    Object.assign(this, props);
    this.member = new Member(props.member);
  }

  public static toSelectItem(alert: IAlert): ISelectItem {
    return {
      text: alert.name,
      value: alert.id,
    };
  }
}

export class AlertRequest implements IAlertRequest {
  public name = "";
  public span = 0;
  public company_id = 0;
  public member_id = 0;
  public tag_id = 0;

  [key: string]: unknown;
}

export class AlertCreateRequest
  extends AlertRequest
  implements IAlertCreateRequest {}

export class AlertUpdateRequest
  extends AlertRequest
  implements IAlertUpdateRequest
{
  public id = 0;

  public constructor(props?: IAlert) {
    super();

    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class AlertListRequest
  extends ListRequest
  implements IAlertListRequest {}
